import React, { useEffect, useState } from "react"
import { createPortal } from "react-dom"

type Props = {
  conceptId: string
  loop?: number
  title?: string
  className?: string
}

const MissieDemo: React.FC<Props> = ({
  conceptId,
  loop = 1,
  title = "Techtok Missies, voorbeeldmissie",
  className = "",
}) => {
  const [open, setOpen] = useState(false)
  const src = `/games/playquest/index.html?preview=concept:${conceptId}:${loop}`

  useEffect(() => {
    if (!open) return
    const prevOverflow = document.body.style.overflow
    document.body.style.overflow = "hidden"
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false)
    }
    window.addEventListener("keydown", onKeyDown)
    return () => {
      document.body.style.overflow = prevOverflow
      window.removeEventListener("keydown", onKeyDown)
    }
  }, [open])

  return (
    <>
      <div
        className={`missie-demo-teaser ${className}`}
        role="button"
        tabIndex={0}
        onClick={() => setOpen(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") setOpen(true)
        }}
        aria-label="Speel de voorbeeldmissie, opent op volledig scherm"
      >
        <div className="missie-demo-notch" aria-hidden="true" />
        <iframe src={src} title={title} tabIndex={-1} aria-hidden="true" className="missie-demo-teaser-iframe" />
        <span className="missie-demo-activate-pill">Tik om te spelen</span>
      </div>

      {open &&
        createPortal(
          // Rendered straight into document.body, not in place here: a
          // squiggle section's CSS mask (used across the site for the wavy
          // section edges) creates a new containing block, which traps a
          // position:fixed element inside its own box instead of covering
          // the viewport. A portal sidesteps that ancestor entirely.
          <div className="missie-demo-modal-backdrop" role="dialog" aria-modal="true" onClick={() => setOpen(false)}>
            <div className="missie-demo-modal" onClick={(e) => e.stopPropagation()}>
              <button className="missie-demo-modal-close" onClick={() => setOpen(false)} aria-label="Sluiten">
                ✕
              </button>
              <div className="missie-demo-modal-frame">
                <div className="missie-demo-notch" aria-hidden="true" />
                <iframe src={src} title={title} className="missie-demo-modal-iframe" />
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  )
}

export default MissieDemo
